import React from 'react';
import './Footer.css';
import bottomLeftMenu from '../../Images/Menus/BottomLeftMenu.png';
import PlayButton from '../PlayButton/PlayButton';
import ModeTab from '../ModeTab/ModeTab';

class Footer extends React.Component {
  render() {
    return (
      <div className="footerDisplay">
        <div className="bottomLeftSection">
          <h1 className="bottomLeftText">High Score<br/>{this.props.highScore > 0 ? this.props.highScore.toLocaleString('en') : 0}</h1>
          <img src={bottomLeftMenu} className="bottomLeftFrame" alt="scoreFrame"/>
        </div>
        <div></div>
        {this.props.mode === "Menu" || this.props.mode === "Game Over" ? <PlayButton beginGame={this.props.beginGame}/> : <ModeTab mode={this.props.mode}/>}
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js